import { Text, View } from "react-native";

type SectionHeaderProps = Readonly<{
  title: string;
  subtitle?: string;
}>;

const SectionHeader = ({ title, subtitle }: SectionHeaderProps) => (
  <View>
    <Text className="text-onyx font-medium text-base">{title}</Text>
    {subtitle && <Text className="text-slate text-sm">{subtitle}</Text>}
  </View>
);


export default SectionHeader;
